import React from "react";

import VasuImage from "../Assets/Images/VasuImage.jpeg";
import RamImage from "../Assets/Images/RamImage2.jpeg";
import FarhanImage from "../Assets/Images/FarhanImage.jpeg";
import PhavanImage from "../Assets/Images/PhavanImage.jpeg";
import ParimalaImage from "../Assets/Images/ParimalaImage.jpeg";
import MathiImage from "../Assets/Images/MathiImage.jpg";
import VivekImage from "../Assets/Images/vivekImage.jpeg";
import PrabhuImage from "../Assets/Images/PrabhuImage.jpeg";
import KaliImage from "../Assets/Images/KaliImage.jpeg";
import AnbarasiImage from "../Assets/Images/AnbarasiImg.jpeg";

const TeamSection = () => {
  const teamMembers = [
    {
      name: "Vasupandiyan R",
      role: "Managing Director",
      image: VasuImage,
    },
    {
      name: "Vivek Kumar A",
      role: "HR Manager",
      image: VivekImage,
    },
    {
      name: "Prabhu",
      role: "Project Manager",
      image: PrabhuImage,
    },
    {
      name: "Ramsurya M",
      role: "Senior Developer & TL",
      image: RamImage,
    },
    {
      name: "Parimala K",
      role: "Flutter Developer",
      image: ParimalaImage,
    },
    {
      name: "Phavaneshwar K",
      role: "Junior Developer",
      image: PhavanImage,
    },
    {
      name: "Kalidoss A",
      role: "BDM",
      image: KaliImage,
    },
    {
      name: "Anbarasi P",
      role: "Junior Developer",
      image: AnbarasiImage,
    },
    {
      name: "Mathiarasan M",
      role: "Senior Developer",
      image: MathiImage,
    },
    {
      name: "Mohamed Farhan M",
      role: "Software Developer",
      image: FarhanImage,
    },
  ];

  return (
    <div className="bg-transparent text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-xl text-[#559bf3] font-bold mb-4 relative inline-block">
            Meet Our Awesome Team
            <div className="absolute -top-2 -right-0 w-4 h-4 bg-[#559bf3] rotate-45"></div>
            <div className="absolute -bottom-2 -left-0 w-4 h-4 bg-[#559bf3] rotate-45"></div>
          </h2>

          <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold">
            We Are Born For Technology
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="group text-center">
              {/* Image Wrapper */}
              <div className="relative mx-auto w-40 h-40 mb-6">
                {/* Blue Glow */}
                <div className="absolute inset-0 rounded-full bg-[#559bf3] opacity-0 blur-2xl scale-90 group-hover:opacity-30 group-hover:scale-110 transition-all duration-500"></div>

                {/* Rotating Ring */}
                <div className="absolute -inset-2 rounded-full border-2 border-dashed border-transparent group-hover:border-[#559bf3] group-hover:rotate-180 transition-all duration-700 ease-out"></div>

                {/* Image */}
                <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-[#559bf3]/40 group-hover:border-[#559bf3] transition-all duration-300 shadow-lg group-hover:shadow-[0_0_35px_rgba(85,155,243,0.6)]">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                  />
                </div>
              </div>

              {/* Name */}
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 transition-colors duration-300 group-hover:text-[#559bf3]">
                {member.name}
              </h3>

              {/* Role */}
              <p className="text-gray-300 text-sm font-semibold transition-colors duration-300 group-hover:text-white">
                {member.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;